
import { SWRConfiguration, SWRResponse } from "swr";

import { ParticipantSourceDataAllocation, QueryParticipantSourceDataAllocations, QueryParticipantSourceDataAllocationsResponse } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';

const getAdditionalState = (response?: SWRResponse<QueryParticipantSourceDataAllocationsResponse, QueryParticipantSourceDataAllocationsResponse>) => ({
    idMap: response?.data?.data?.reduce<Record<number, ParticipantSourceDataAllocation>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{})
});

const sortData = (a: ParticipantSourceDataAllocation, b: ParticipantSourceDataAllocation) => a.participantId! > b.participantId! ? 1 : -1;

export const useParticipantSourceDataAllocations = (query?: Partial<ParticipantSourceDataAllocation>, configuration?: SWRConfiguration | undefined) => {
    return useCachedDataQuery(QueryParticipantSourceDataAllocations, { sortData, getAdditionalState, channel: AppSettings.channels.participant }, query, configuration);
}

export default useParticipantSourceDataAllocations;